import {defineComponent, onMounted, ref} from 'vue';
import userLocalStorage from '@/storage/user-local-storage';
import {ICreateOrUpdateMapRequestInput} from '@/api/klip-api.proxy';

export interface IKlMriCreateStep1Result {
    maprequestType: string;
    isValid: boolean;
}

export default defineComponent({
    name: 'KlMriCreateStep1',
    emits: ['submit'],
    props: {
        isCreate: {type: Boolean, required: false, default: true},
        prefill: {type: Object as () => ICreateOrUpdateMapRequestInput, required: false, default: null},
    },
    setup(props, { emit }) {

        const typeLocalStorageKey = 'mri_create_pa_type';

        const maprequestType = ref<string>();

        /**
         * When type is changed in the first step,
         * remember users choice in cookie
         */
        const _saveType = () => {
            if (maprequestType.value) {
                userLocalStorage.setItem(typeLocalStorageKey, maprequestType.value);
            }
        }

        /**
         * @NOTE
         * maprequestTypes (this.viewModel.mapRequestTypes)
         * are not usefull in the front-end
         * Important to keep the keys klipdecree and studyphase
         * in place since they're used by other logic
         */
        const maprequestTypes = [
            {
                key: 'klipdecree',
                title: 'Uitvoering grondwerken',
                description: 'Verplicht aan te vragen, vanaf 40 werkdagen vóór de geplande start van de werken.',
            }, {
                key: 'studyphase',
                title: 'Studiefase',
                description: 'Enkel te gebruiken voor voorbereidend onderzoek. Voor het daadwerkelijk uitvoeren van grondwerken, dient u een planaanvraag \'Uitvoering grondwerken\' in.',
            },
        ];

        function gotoStep2() {
            _saveType();

            emit('submit', <IKlMriCreateStep1Result>{
                maprequestType: maprequestType.value,
                isValid: !!maprequestType.value,
            });
        }

        const _prefillPreferences = () => {
            const preferred = userLocalStorage.getItem(typeLocalStorageKey);
            if (props.isCreate && preferred) {
                maprequestType.value = preferred;
            }
        }

        onMounted(async () => {
            _prefillPreferences();

            if (props.prefill?.mapRequestType) {
                maprequestType.value = props.prefill.mapRequestType;
            }
        });

        return {
            maprequestType,
            maprequestTypes,
            gotoStep2,
        }

    }
});
